const getRegex = (string: string | RegExp) => new RegExp(string, "u");

export const hasLowerCaseRegex = getRegex("^.*[a-z].*$");
export const hasUpperCaseRegex = getRegex("^.*[A-Z].*$");
export const hasSpecialCharsRegex = getRegex(
  "^.*[`!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?~].*$"
);
export const hasDigitsRegex = getRegex("^.*[+0-9].*$");
export const latinCharactersRegex = getRegex(/^[A-Za-z0-9(),.`\-&\s]*$/);
